import { pkg } from './pkg.js';

export const userAgent = `${pkg.name} ${pkg.version}`;
